import React from 'react'
import { connect } from 'react-redux'
import { Button, Space } from 'antd'
import classNames from 'classnames'
import { MessageFilled, UsergroupAddOutlined, PullRequestOutlined } from '@ant-design/icons'
import actions from 'redux/virtual/chat/actions'
import AttendeeMessageWindow from '../../InternalComponent/Attendees'
// import Messages from '../../InternalComponent/Messages'
import styles from '../../style.module.scss'

const mapStateToProps = ({ Chat, virtualUser }) => ({ Chat, virtualUser })

@connect(mapStateToProps)
class HomeScreen extends React.Component {
  closeSettings = () => {
    const { dispatch } = this.props
    dispatch({
      type: 'virtualSettings/CHANGE_SETTING',
      payload: {
        setting: 'isSidebarOpen',
        value: false,
      },
    })
  }

  changeTab = event => {
    const { dispatch } = this.props
    const theTab = event.target.getAttribute('data-value')
    if (theTab === 'attendees') {
      dispatch({
        type: actions.GET_ALL_USERS,
      })
    }
    dispatch({
      type: actions.SET_STATE,
      payload: {
        currentTab: theTab,
      },
    })
  }

  render() {
    const {
      Chat: { currentTab },
      virtualUser: { roles },
    } = this.props
    return (
      <div className={styles.container}>
        <button
          className={`${styles.close} fa fa-times`}
          onClick={this.closeSettings}
          type="button"
        />
        <h2 className={styles.mediah2}>Chat</h2>
        <h4 className={styles.mediah4}>Start New Conversation</h4>
        <br />
        <Space>
          <Button
            type="primary"
            shape="round"
            className={classNames({
              [styles.radioButtonChat]: true,
              [styles.radioButtonChatActive]: currentTab === 'messages',
            })}
            data-value="messages"
            icon={<MessageFilled />}
            onClick={this.changeTab}
          >
            Messages
          </Button>

          {roles.includes('ROLE_EXHIBITOR') ? (
            <Button
              type="primary"
              shape="round"
              className={classNames({
                [styles.radioButtonChat]: true,
                [styles.radioButtonChatActive]: currentTab === 'requests',
              })}
              data-value="requests"
              icon={<PullRequestOutlined />}
              onClick={this.changeTab}
            >
              Requests
            </Button>
          ) : (
            <Button
              type="primary"
              shape="round"
              className={classNames({
                [styles.radioButtonChat]: true,
                [styles.radioButtonChatActive]: currentTab === 'attendees',
              })}
              data-value="attendees"
              icon={<UsergroupAddOutlined />}
              onClick={this.changeTab}
            >
              Attendees
            </Button>
          )}

          {/* <Button type="primary" shape="round" className={styles.radioButtonChat} icon={<UsergroupAddOutlined />}>
            Attendees
          </Button> */}
        </Space>
        <br />
        <AttendeeMessageWindow />
        {/* {
          currentTab === "attendees"
          ?
            <Attendees />
          :
            <Messages />
        } */}
      </div>
    )
  }
}

export default HomeScreen
